import {SclMapViewsService} from './scl-map-views.service';
import {isNumber, cloneDeep} from 'lodash';
import { SclUtilMapService } from './scl-util-map.service';

const sclMapViews = new SclMapViewsService();


export class MapLibraryName {
    static OPEN_LAYER = 'openlayers';
    static GOOGLE = 'google';
    static ARC_GIS = 'arcGIS';
}

export class MapComponentName {
    static BOUNDARY = 0; // SclMapConstantService.
    static ADDRESS_MAP = 1;
    static STREET_ADDRESS = 2;
    static SELECTED_ASSET = 3;
}

export class MapDrawMode {
    static ALL = 0;
    static SINGLE = 1;
    static MULTI = 2;
}

export class MapDrawType {
    static NA = null;
    static POINT = 'Point';
    static LINE_STRING = 'LineString';
    static POLYGON = 'Polygon';
    static CIRCLE = 'Circle';
    static SQUARE = 'Square';
    static BOX = 'Box';
    static MULTI_POINT = 'MultiPoint';
    static MULTI_LINE_STRING = 'MultiLineString';
    static MULTI_POLYGON = 'MultiPolygon';
    static TEXT = 'text';
    static MARKER = 'Marker';
}

export class MapDrawTypeSpecial {
    static TEXT_BOX = 'text';
    static ARROW_AT_FIRST_POINT = 'atFirstPoint';
    static ARROW_AT_LAST_POINT = 'atLastPoint';
    static ICON = 'icon';
    static DIMENSION = 'dimension';
}

export class ShapeIdGroup {
    static MULTI_POINT = 'mp';
    static MULTI_RECTANGLE = 'mr';
    static MULTI_POLYGON = 'mo';
    static MULTI_LINE_STRING = 'ml';
    static MULTI_CIRCLE = 'mc';
    static MULTI_SQUARE = 'ms';
    static MULTI_ARROW_AT_FIRST_POINT = 'maf';
    static MULTI_ARROW_AT_LAST_POINT = 'mal';
}

export class MapDrawStyling {
    static COLOR = 'dsc';
    static LINE_WIDTH = 'dslw';
    static LINE_DASH = 'dsld';
    static ICON = 'dsi';
    static FONT = 'dsf';
    static FONT_SIZE = 'dsfs';
}

export class MapDrawAction {
    static SELECT = 'select';
    static MENU = 'menu';
    static DELETE = 'delete';
    static LOCATION = 'location';
    static EDIT = 'edit';
    static MODE = 'mode';
    static PROPERTIES = 'properties';
    static NA = '';
}

export class MapSelectAssetMode {
    static POINT = 'point';
    static ASSET = 'asset';
}

export class MapSelectAssetType {
    static PRIMARY = 'primaryAsset';
    static SECONDARY = 'secondaryAsset';
    static STREET = 'street';
}

export class GEOJSON_TYPE {
    static FEATURE_COLLECTION = 'FeatureCollection';
}

export class FEATURE_TYPE {
    static FEATURE = 'Feature';
    static GEOMETRY_COLLECTION = 'GeometryCollection';
}

export class MapLibrary {
    libName: any;
    bounds: any;
    onTilesLoaded: any;
    fitCoordCount: number;
    addressImageAnchor: any;
    primaryImageAnchor: any;
    secondaryImageAnchor: any;
    drawType = MapDrawType.NA;
    psmaReverse: any;
    actionType = MapDrawAction.NA;
    map = null;
    marker = null;
    setDirtyFunction = null;
    singleColor = 'black'; multiColor = 'red' ; // for sc-boundary
    singleColorDraging = 'blue'; multiColorDraging = 'green';
    selectionStyle = null;
    selectedAssets = []; // use for selected asset
    openSansAdded = false;
    layerAssets = [];
    layerIndexFilter = -1;
    layerIndexUser = -1;
    layerIndexAddress = -1;
    layerIndexPrimary = -1;
    layerIndexSecondary = -1;
    layerIndexTooltips = -1;
    layerIndexControl = -1;
    primaryAssetSelection = null;
    secondaryAssetSelection = null;
    isDrawModeSingle = true; // for sc-boundary
    modeLabel = null; // for sc-boundary
    heightNum = 1;
    lstHeatWeight = []; heatDatas = []; // heatmap
    defaultZoom = null; defaultLat = null; defaultLon = null;
    zoomFloor;
    compActionType = ''; // 14310: '' = no action, 'primary', 'secondary', ....
    isMapReady = false;
    toolTipOnFeatureHover = null; // 15141#c57727
    setupTooltipUI = null;
    fullScreenEvent; // 15336#c59379
    mapDiv = null;
    clusterClick; // 15251#c59696
    getLocationFn; // sc-boundary : 14786#c56443 & 16222
    drawingMenu;
    drawButtonsForOnlySingleMode = [];
    drawMenuChild = null;
    pointBtn = null; lineBtn = null; polygonBtn = null;
    circleBtn = null; boxBtn = null; colorWrapper = null;
    squareBtn = null;
    lineWidthWrapper = null; lineDashWrapper = null;
    iconWrapper = null;
    textBtn = null; arrowFirstPointBtn = null; arrowLastPointBtn = null
    menuBtn = null; menuPointBtn = null; menuLineBtn = null;
    menuPolygonBtn = null; menuCircleBtn = null; 
    menuBoxBtn = null; menuWrapper = null;
    menuSquareBtn = null;
    menuColorBtn = null; menuColorLabel = null;
    menuLineWidthBtn = null; menuLineWidthLabel = null;
    menuLineDashBtn = null; menuLineDashLabel = null;
    menuTextBtn = null; menuArrowFirstPointBtn = null; menuArrowLastPointBtn = null;
    menuIconBtn = null; menuIconLabel = null;
    menuSelectBtn = null; menuSelectLabel = null;
    isBottom = false;
    drawToolButtonSize = 40;
    isDrawCircleAsPolygon = false;
    showTooltip = true;
    allowDrawingMode = MapDrawMode.ALL;
    drawingToolDefault = ['point', 'line', 'polygon', 'single', 'multi', 'currentLocation', 'delete'];
    drawingTools = [];
    drawingToolsFromConfig = [];
    drawingToolsSupported = [];
    totalDrawTool = 0;
    locationElementIcon = null;
    locationChecked = false;
    hasDocumentChangeValue = false;
    cacheImageUrls = []; // store the image url
    cacheImageBase64s = []; // store the image with base64 string of cacheImageUrls
    cacheImages = []; // store the image of cacheImageUrls
    cacheImageRequesting = []; // store the image which is fetching
    cacheImageModifiedBase64 = []; // store the image already rotated ( base 64 )
    cacheImageModifiedInfo = []; // store the image's info of image already rotated : url#rotateValue
    cacheImageModifiedInfoRequesting = [];
    mapType = -1; // 0 : boundary, 1 : address, 2: street-address, 3: selected-asset
    heightMapInit = 0; // 15755
    showSubMenuDrawStylingFunc = {}; // storing functions to hide menu child of drawing style. Ex: <color, hideFunction>
    controlBtns = [];
    isFullScreen = false;
    drawStylingButtonCss;
    // draw color
    drawColors = [];
    colorWrapperShow = false;
    colorCurrentSelected;
    // draw line width
    drawWidths = [];
    lineWidthWrapperShow = false;
    lineWidthCurrentSelected;
    // draw line dash
    drawDashes = [];
    lineDashWrapperShow = false;
    lineDashCurrentSelected;
    elementWrapperForBottomPosition;
    keyName;
    cssLineDashDiv = {};
    // draw text box
    closeTextBox;
    currentCloseTextBoxFn;
    currentTextBoxId;
    allowCreateNewTextBox = true;
    isPressKeyEscape = false;
    drawTypeSpecific = null;
    // draw arrow
    iconArrowWhiteBase64 = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAIpJREFUSEvV1cEOgDAIA1D5/4/GaIKHObC0XPQ2TfrSuTA7lsfd/XplZrZ+Y9avkAAiTIU+AbUNBCgIDLBIC2D+CwV02tAAikgAsmUjQNVmDMiQUWCH/AvYza2xBtlQHAGqiSsByCinAST8PlXZjVbdXmh4G+gEP2MEbcCEww3YcAhQwktADY6tPwFHBGAZE4MTKAAAAABJRU5ErkJggg==';
    // draw icon
    drawIcons = [];
    iconWrapperShow = false;
    iconCurrentSelected; iconAnchorCurrentSelected = [0.5, 0.5];
    cssIconDiv = {};
    cssIconButtonChild = 'draw-icon-button-icon';
    // dimension
    dimensionsUnit = 'm'; // "km" | "m" | "mm" // kilometers, metres (default, if not present), millimeters
    dimensionsPrecision = 2; // number of decimal places to round dimension value to
    menuDimensionBtn = null;
    dimensionBtn = null;
    dimensionEditorContainer = null;
    dimensionEditorInput = null;
    dimensionEditorCloseButton = null;
    closeDimensionEditorFn = null;
    dimensionEditorRecalculateButton = null;
    reCalculateDimensionFn = null;
    previousDimensionValue = null;
    // draw font family
    drawFonts = [];
    fontWrapperShow = false;
    fontWrapper = null;
    menuFontBtn = null;
    menuFontLabel = null;
    fontCurrentSelected = null;
    fontBtn = null;
    // draw font size
    drawFontSizes = [];
    fontSizeWrapperShow = false;
    fontSizeWrapper = null;
    menuFontSizeBtn = null;
    menuFontSizeLabel = null;
    fontSizeCurrentSelected = null;
    fontSizeBtn = null;
    // cursor when drawing text box
    drawTextCursor = null;
    drawTextCursorId = 'textBoxCursor';
    sketch = null;
    textBoxOnMouseUp = null;
    isDebugRotate = false;
    boundingRectangle = null;
    boundingRectangleFeature = null;
    boundPadding = 200;
    rotateObjectId = null;
    rotateObject = null;
    THRESHOLD_MIN = 0.04; // default for openlayers
    THRESHOLD_MAX = 0.06; // default for openlayers
    allowRotate = false;
    rotateSpeed = 0.03; // default for openlayers
    hasRotate = false;
    componentDefinition = null;
    mapViewLayers: any = [];
    isOnline = true;
    sclUtilMapService: any;

    constructor() {
        this.showSubMenuDrawStylingFunc = {
            [MapDrawStyling.COLOR]: this.showSubMenuColor.bind(this),
            [MapDrawStyling.LINE_WIDTH]: this.showSubMenuLineWidth.bind(this),
            [MapDrawStyling.LINE_DASH]: this.showSubMenuLineDash.bind(this),
            [MapDrawStyling.ICON]: this.showSubMenuIcon.bind(this),
            [MapDrawStyling.FONT]: this.showSubMenuFont.bind(this),
            [MapDrawStyling.FONT_SIZE]: this.showSubMenuFontSize.bind(this),
        };
        this.sclUtilMapService = new SclUtilMapService();
    }
    async init(initObj, keyName) {
        this.mapType = initObj.style;
        this.keyName = keyName;
        
        if (initObj.color) { this.singleColor = initObj.color; }
        if (initObj.multiColor) { this.multiColor = initObj.multiColor; }
        if (initObj.setDirty) { this.setDirtyFunction = initObj.setDirty; }
        if (initObj.onTilesLoaded) { this.onTilesLoaded = initObj.onTilesLoaded; }
        if (initObj.heightNum) { this.heightNum = initObj.heightNum; }
        if (initObj.zoomFloor) { this.zoomFloor = initObj.zoomFloor; }
        if (initObj.toolTipOnFeatureHover) { this.toolTipOnFeatureHover = initObj.toolTipOnFeatureHover; }
        if (initObj.setupTooltipUI) { this.setupTooltipUI = initObj.setupTooltipUI; }
        if (initObj.target) { 
            this.mapDiv = initObj.target; 
            this.heightMapInit = initObj.target.offsetHeight;
        }
        if (initObj.fullScreenEvent) { this.fullScreenEvent = initObj.fullScreenEvent; }
        if (initObj.clusterClick) { this.clusterClick = initObj.clusterClick; }
        if (initObj.getLocationFn) { this.getLocationFn = initObj.getLocationFn; }
        this.isDrawCircleAsPolygon = (initObj.isDrawCircleAsPolygon ? initObj.isDrawCircleAsPolygon : false);
        if (initObj.componentDefinition) {
            this.componentDefinition = initObj.componentDefinition;
            if (this.componentDefinition.drawingMode) {
                this.isDrawModeSingle = (this.componentDefinition.drawingMode === 'single' ?
                 true : false);
            }

            this.allowDrawingMode = (this.isDrawModeSingle ? MapDrawMode.SINGLE
                : MapDrawMode.MULTI);
            
            if (this.componentDefinition.drawingTools === undefined || this.componentDefinition.drawingTools === null) {
                this.componentDefinition.drawingTools = cloneDeep(this.drawingToolDefault);
            }
        
            if (this.componentDefinition.drawingTools) {
                this.drawingToolsFromConfig = this.componentDefinition.drawingTools;
                if ((this.isDrawModeSingle && this.drawingToolsFromConfig.indexOf('multi') > -1)
                    || (!this.isDrawModeSingle && this.drawingToolsFromConfig.indexOf('single') > -1)) {
                    this.allowDrawingMode = MapDrawMode.ALL;
                }
            }

            if (this.componentDefinition.drawColors
                 && Array.isArray(this.componentDefinition.drawColors)
                 && this.componentDefinition.drawColors.length > 0) {
                this.drawColors = this.componentDefinition.drawColors;
                this.drawingTools.push('colors');
            }

            if (this.componentDefinition.drawWidth
                && Array.isArray(this.componentDefinition.drawWidth)
                && this.componentDefinition.drawWidth.length > 0) {
                this.drawWidths = this.componentDefinition.drawWidth;
                this.drawingTools.push('lineWidth');
            }

            if (this.componentDefinition.drawDash
                && Array.isArray(this.componentDefinition.drawDash)
                && this.componentDefinition.drawDash.length > 0) {
                this.drawDashes = this.componentDefinition.drawDash;
                this.drawingTools.push('lineDash');
            }

            if (this.componentDefinition.drawIcon
                && Array.isArray(this.componentDefinition.drawIcon)
                && this.componentDefinition.drawIcon.length > 0) {
                this.drawIcons = this.componentDefinition.drawIcon;
                this.drawingTools.push('icon');
            }

            if (this.componentDefinition.dimensionsUnit && 
                typeof(this.componentDefinition.dimensionsUnit) === 'string') {
                this.dimensionsUnit = this.componentDefinition.dimensionsUnit.toLowerCase();
            }
            if (this.componentDefinition.dimensionsPrecision) {
                const n = new Number(this.componentDefinition.dimensionsPrecision);
                if (isNumber(n)) {
                    this.dimensionsPrecision = this.componentDefinition.dimensionsPrecision;    
                }
            }

            if (this.componentDefinition.drawFont
                && Array.isArray(this.componentDefinition.drawFont)
                && this.componentDefinition.drawFont.length > 0) {
                this.drawFonts = this.componentDefinition.drawFont;
                this.drawingTools.push('fontFamily');
            }
            if (this.componentDefinition.drawFontSize
                && Array.isArray(this.componentDefinition.drawFontSize)
                && this.componentDefinition.drawFontSize.length > 0) {
                this.drawFontSizes = this.componentDefinition.drawFontSize;
                this.drawingTools.push('fontSize');
            }
        }
        if (this.heightNum < 3) {
            this.isBottom = true;
        } else {
            this.isBottom = false;
        }
        if (this.mapType === MapComponentName.BOUNDARY && this.heightNum < 3
            || (this.mapType === MapComponentName.SELECTED_ASSET &&  this.heightNum === 1)) {// sc-boundary
           this.isBottom = true;
        } else {
           this.isBottom = false;
        }

        if (this.mapType === MapComponentName.BOUNDARY) {
            this.closeTextBox = document.getElementById(`${this.keyName}_closeTextBox`);
            document.addEventListener('keyup', (event) => {
        
                if (event.key === 'Escape') {
                    //if esc key was not pressed in combination with ctrl or alt or shift
                    const isNotCombinedKey = !(event.ctrlKey || event.altKey || event.shiftKey);
                    if (isNotCombinedKey) {
                        // console.log('Escape key was pressed with out any group keys');
                        switch(this.drawType) {
                            case MapDrawType.TEXT: // ol
                                if (typeof this.currentCloseTextBoxFn === 'function') {
                                    this.allowCreateNewTextBox = true;
                                    this.isPressKeyEscape = true;
                                    this.currentCloseTextBoxFn();
                                }
                                break;
                            case MapDrawType.CIRCLE:
                            case MapDrawType.SQUARE:
                            case MapDrawType.BOX:
                                this.cancelDrawing();
                                break;
                            case MapDrawType.LINE_STRING:
                            case MapDrawType.POLYGON:
                            case MapDrawType.MULTI_LINE_STRING:
                            case MapDrawType.MULTI_POLYGON:
                                this.finishDrawing();
                                break;
                            default: break;
                        }
                    }
                } else if (event.key === 'Delete' || event.key === 'Backspace') {
                    this.deleteSelectedShape();
                }
            });

            this.dimensionEditorContainer = document.getElementById(`${this.keyName}_dimension_editor_container`);
            this.dimensionEditorInput = document.getElementById(`${this.keyName}_dimension_editor_input`);
            this.dimensionEditorCloseButton = document.getElementById(`${this.keyName}_dimension_editor_close`);
            if (this.dimensionEditorCloseButton) {
                this.dimensionEditorCloseButton.onclick = (e) => {
                    if (typeof this.closeDimensionEditorFn === 'function') {
                        this.closeDimensionEditorFn();
                    }
                }
            }
            

            this.dimensionEditorRecalculateButton = document.getElementById(`${this.keyName}_dimension_eitor_re_calculate`);
            if (this.dimensionEditorRecalculateButton) {
                this.dimensionEditorRecalculateButton.onclick = (e) => {
                    if (typeof this.reCalculateDimensionFn === 'function') {
                        this.reCalculateDimensionFn();
                    }
                }
            }
        }

        
        
    }

    createDrawButton(id, title, text, css, actionFunction, isMaterialIcon, drawSpecific) {
        const btn = sclMapViews.createUIButton(document, actionFunction, 'ol-has-tooltip', title, null );
        let iSpan = null;
        if (drawSpecific === MapDrawTypeSpecial.ICON) {
            iSpan = document.createElement('div');            
            Object.assign(iSpan.style, this.cssIconDiv);
        } else {
            iSpan = document.createElement('i');
            if (isMaterialIcon) {
                iSpan.setAttribute('class', 'material-icons');
            }
            iSpan.innerHTML = text;
        }
        iSpan.id = id + '_icon';

        btn.appendChild(iSpan);
        btn.id = id;
    
        if (css) {
            Object.assign(btn.style, css);
        }

        return { btn, iSpan };
    }

    hideDrawTool(element) {
        if (!element) { return; }
        element.style.display = 'none';
    }
    hideDrawTools() {
        this.hideDrawTool(this.pointBtn);
        this.hideDrawTool(this.lineBtn);
        this.hideDrawTool(this.polygonBtn);
        this.hideDrawTool(this.circleBtn);
        this.hideDrawTool(this.boxBtn);
        this.hideDrawTool(this.textBtn);
        this.hideDrawTool(this.colorWrapper);
        this.hideDrawTool(this.lineWidthWrapper);
        this.hideDrawTool(this.lineDashWrapper);
        this.hideDrawTool(this.iconWrapper);
        this.hideDrawTool(this.arrowFirstPointBtn);
        this.hideDrawTool(this.arrowLastPointBtn);
        this.hideDrawTool(this.dimensionBtn);
        this.hideDrawTool(this.fontWrapper);
        this.hideDrawTool(this.fontSizeWrapper);
    }
    showMenuChilds(isShow) {
        const display = isShow ? 'block': 'none';
        if (this.menuPointBtn) { this.menuPointBtn.style.display = display; }
        if (this.menuLineBtn) { this.menuLineBtn.style.display = display; }
        if (this.menuArrowFirstPointBtn) { this.menuArrowFirstPointBtn.style.display = display; }
        if (this.menuArrowLastPointBtn) { this.menuArrowLastPointBtn.style.display = display; }
        if (this.menuPolygonBtn) { this.menuPolygonBtn.style.display = display; }
        if (this.menuCircleBtn) { this.menuCircleBtn.style.display = display; }
        if (this.menuBoxBtn) { this.menuBoxBtn.style.display = display; }
        if (this.menuTextBtn) { this.menuTextBtn.style.display = display; }
        if (this.menuColorBtn) { this.menuColorBtn.style.display = display; }
        if (this.menuLineWidthBtn) { this.menuLineWidthBtn.style.display = display; }
        if (this.menuLineDashBtn) { this.menuLineDashBtn.style.display = display; }
        if (this.menuIconBtn) { this.menuIconBtn.style.display = display; }
        if (this.menuDimensionBtn) { this.menuDimensionBtn.style.display = display; }
        if (this.menuFontBtn) { this.menuFontBtn.style.display = display; }
        if (this.menuFontSizeBtn) { this.menuFontSizeBtn.style.display = display; }
        if (!isShow) {
          this.showStylingSubMenu(null, isShow);
        }
    }
    
    btnAddEvent(btn) {
        if (!btn) { return; }
        btn.onmouseover = function() {
            if (btn.style.backgroundColor === 'grey') { return; }
            btn.style.backgroundColor = 'lightgrey';
        };
        btn.onmouseout = function() {
            if (btn.style.backgroundColor === 'grey') { return; }
            btn.style.backgroundColor = 'white';
        };
    }
    updateDrawingSubMenuCss(mapDivSize) {
        if (!mapDivSize || !this.menuBtn || !this.drawMenuChild) { return; }

        const availableCountDrawTool = (this.isDrawModeSingle ? this.totalDrawTool :
        this.totalDrawTool - this.drawButtonsForOnlySingleMode.length);
        const sizeMenuChilds = availableCountDrawTool * this.drawToolButtonSize;

        let isMultiLines = false;
    
        if (this.isBottom) {
          const heighRemain = mapDivSize - this.menuBtn.offsetHeight - 10;
    
        //   console.log(`**** sub menu height = ${this.drawMenuChild.offsetHeight}`
        //         + `\n, mapDivSize = ${mapDivSize}, button menu height = ${this.menuBtn.offsetHeight}`
        //         + `\n, heighRemain = ${heighRemain}`);
    
          if (sizeMenuChilds > heighRemain) {
            this.drawMenuChild.style.height = `${heighRemain}px`;
            this.drawMenuChild.style.top = `${-heighRemain}px`;
    
            // this.drawMenuChild.style.overflow = 'scroll';
            // this.drawMenuChild.style['overflow-x'] = 'hidden';
            this.drawMenuChild.scrollTop = heighRemain;
            isMultiLines = true;
          } else {
            this.drawMenuChild.style.removeProperty('height');
            // this.drawMenuChild.style.removeProperty('overflow');
            // this.drawMenuChild.style.removeProperty('overflow-x');
            
      
            this.drawMenuChild.style.top = `${-sizeMenuChilds}px`;
            isMultiLines = false;
          }
          
        } else {
          const widthRemain = mapDivSize - this.menuBtn.offsetWidth - 10;
          if (sizeMenuChilds > widthRemain) {
            this.drawMenuChild.style.width = `${widthRemain}px`;
            this.drawMenuChild.style.left = `${this.drawToolButtonSize}px`;
            isMultiLines = true;
          } else {
            this.drawMenuChild.style.removeProperty('width');
    
            this.drawMenuChild.style.left = `${this.drawToolButtonSize}px`;
            isMultiLines = false;
          }
        }
        if (isMultiLines) {
            this.drawMenuChild.style['flex-wrap'] = 'wrap';
            this.drawMenuChild.style['align-content'] = 'flex-start';
        } else {
            this.drawMenuChild.style.removeProperty('flex-wrap');
            this.drawMenuChild.style.removeProperty('align-content');
        }
    }
    updateMenuStylePositionForBottom(menuBtnElement, childWrapper) {
        const mapDivSize = this.elementWrapperForBottomPosition?.offsetHeight;
        if (!mapDivSize) { return; }


        // calculate relative position of element child in parent
        const parentPos = this.elementWrapperForBottomPosition?.getBoundingClientRect();
        const childPos  = menuBtnElement?.getBoundingClientRect();
        const top = childPos?.top - parentPos?.top;
        const left = childPos?.left - parentPos?.left;
        const bottom = Math.abs(childPos?.bottom - parentPos?.bottom);
        // console.log(`***** top = ${top}, childPos.top = ${childPos?.top}
        // , parentPos.top = ${parentPos?.top}
        // , \nbottom = ${bottom}, childPos.bottom = ${childPos?.bottom}
        // , parentPos.bottom = ${parentPos?.bottom}`);
        const css: any = {
            display: 'flex',
        };
        if (this.drawMenuChild?.style?.overflow) {
            css.left = `${(left + this.drawMenuChild?.offsetWidth)}px`;
        } else {
            css.left = `${(left + this.drawToolButtonSize)}px`;
        }
        childWrapper?.style.removeProperty('top');
        childWrapper?.style.removeProperty('bottom');
        if (this.isFullScreen) {
            css.bottom = `${bottom}px`;
        } else {
            css.top = `${top}px`;
        }
        
        Object.assign(childWrapper?.style, css);
    }
    showSubMenuStylingWrapper(isShow, wrapperElement, wrapperStatus, menuBtnElement) {
        if (!wrapperElement) { return; }
        wrapperStatus = isShow;
        if (isShow) {
            if (this.isBottom) {
                this.updateMenuStylePositionForBottom(menuBtnElement, wrapperElement);
            } else {
                wrapperElement.style.display = 'inline-flex';
                wrapperElement.style['flex-direction'] = 'column';
                //
                
                let index = -1;
                for (let i = 0; i < this.drawMenuChild.children.length; i++) {
                    if (this.drawMenuChild.children[i].id == menuBtnElement.id) {
                        index = i;
                        break;
                    }
                }
                const space = 2; // space between 2 buttons
                // const wrapperRealHeight = (wrapperElement.children.length * this.drawToolButtonSize)
                // + (wrapperElement.children.length * space);
                const wrapperRealHeight = (wrapperElement.children.length * this.drawToolButtonSize);
                
                // const factor = this.mapDiv.offsetHeight - totalMenuToolOpeningHeight;
                const factor = this.mapDiv.offsetHeight - wrapperRealHeight;
                // console.log(`*** map.height = ${this.mapDiv.offsetHeight}
                // , menu.height = ${this.drawMenuChild.offsetHeight}
                // , wrapper.height = ${wrapperElement.offsetHeight}
                // , wrapperRealHeight = ${wrapperRealHeight}
                // , factor = ${factor}, index = ${index}
                // , wrapper.id = ${wrapperElement.id}`);

                if (factor < 0) {
                    const height = this.mapDiv.offsetHeight - ((index + 1) * this.drawToolButtonSize)
                     - ((index + 1) * space) - this.drawToolButtonSize
                     - wrapperElement.children.length;
                    // console.log(`***** height = ${height}`);
                    wrapperElement.style.height = `${Math.abs(height)}px`;
                    wrapperElement.style.overflow = 'scroll';
                    wrapperElement.style['overflow-x'] = 'hidden';
                    wrapperElement.style.bottom = '-15px';
                } else {
                    wrapperElement.style.removeProperty('height');
                    wrapperElement.style.removeProperty('overflow');
                    wrapperElement.style.removeProperty('overflow-x');
                    wrapperElement.style.height = `${wrapperRealHeight}px`;
                }
                
            }
        } else {
            wrapperElement.style.display = 'none';
        }
        return wrapperStatus;
    }
    showStylingSubMenu(currentStyling, isShow) {
        for (let key in this.showSubMenuDrawStylingFunc) {
            if (key === currentStyling) {
                continue;
            }
            this.showSubMenuDrawStylingFunc[key](isShow);
        }
    }

    // draw colors
    showSubMenuColor(isShow) {
        this.colorWrapperShow = this.showSubMenuStylingWrapper(isShow, this.colorWrapper, this.colorWrapperShow
            , this.menuColorBtn);
    }
    colorAction(e) {
        this.showStylingSubMenu(MapDrawStyling.COLOR, false);
        this.colorWrapperShow = !this.colorWrapperShow;
        this.showSubMenuColor(this.colorWrapperShow);
    }
    setColorForButtonColor(element, color) {
        if (element) {
            const css = { 'background-color': color, color };
            Object.assign(element.style, css);
        }
        
    }
    setColorForMenuDrawColor(color) {
        this.setColorForButtonColor(this.menuColorLabel, color);
    }
    drawColorChildAction(e, childIndex) {
        e.stopPropagation();
        if (childIndex < this.drawColors.length) {
            this.setColorForMenuDrawColor(this.drawColors[childIndex]);
            this.colorCurrentSelected = this.drawColors[childIndex];
        }
    }
    createADrawButtonStyle(i, id, title, text, css, onClickFn, wrapper, layerIds
        , styleFn, style, isMaterialIcon, drawSpecific) {
        // console.log(`**** createADrawButtonStyle, css = `, css);
        const obj = this.createDrawButton(id, title, text, css, null, isMaterialIcon, drawSpecific);
        obj.btn.addEventListener('click', (e) => {
            onClickFn(e, i);
        });
        styleFn(obj.iSpan, style);

        if (drawSpecific === MapDrawStyling.FONT) {
            obj.btn.style.width = 'auto';
        }

        this.btnAddEvent(obj.btn);
        layerIds.push(obj.btn.id);
        wrapper.appendChild(obj.btn);

        return layerIds;
    }
    createDrawButtonStyling(compId, layerIds, css, arr, wrapper
        , wrapperSubId, wrapperCssBottom, wrapperCssMiddleLeft
        , onClickFn, styleFn, menuBtnStyling
        , childBtnSubId, btnText, parentForBottomPosition, isMaterialIcon, drawSpecific
        , titleFieldName) {
        if (arr.length > 0) {
            wrapper = document.createElement('div');
            wrapper.id = compId + wrapperSubId;
            wrapper.style['z-index'] = 2;
            
            for (let i = 0; i < arr.length; i++) {
                let title = arr[i];
                if (titleFieldName == MapDrawStyling.ICON) {
                    title = arr[i].fileNo;
                } else if (titleFieldName == MapDrawStyling.LINE_DASH) {
                    if (Array.isArray(arr[i]) && arr[i].length == 2) {
                        title = `[${arr[i][0]}, ${arr[i][1]}]`;
                    } else {
                        title = `invalid line dash value`;
                    }
                    
                }
                layerIds = this.createADrawButtonStyle(i, compId + childBtnSubId + i
                , title
                , btnText, css
                , onClickFn
                , wrapper, layerIds
                , styleFn
                , arr[i]
                , isMaterialIcon
                , drawSpecific);
            }
            if (this.isBottom) {
                wrapper.setAttribute('class', wrapperCssBottom);
                parentForBottomPosition.appendChild(wrapper);
            } else {
                wrapper.setAttribute('class', wrapperCssMiddleLeft);
                menuBtnStyling.appendChild(wrapper);
            }
        }
        return {layerIds, wrapper};
    }


    // draw line width
    lineWidthAction(e) {
        this.showStylingSubMenu(MapDrawStyling.LINE_WIDTH, false);
        this.lineWidthWrapperShow = !this.lineWidthWrapperShow;
        this.showSubMenuLineWidth(this.lineWidthWrapperShow);
    }
    showSubMenuLineWidth(isShow) {
        this.lineWidthWrapperShow = this.showSubMenuStylingWrapper(isShow, this.lineWidthWrapper
            , this.lineWidthWrapperShow, this.menuLineWidthBtn);
    }
    setWidthForButtonLineWidth(element, width) {
        if (element) {
            element.innerHTML = '';
            
            // create a icon for line width and is a child of <i> tag
            const icon = document.createElement('div');
            const css = {
                'height': `${this.drawToolButtonSize / 2}px`,
                'width': `${width}px`,
                'border-radius': '5px',
                'background-color': 'black',
                'transform': 'rotate(30deg)'
            };
            Object.assign(icon.style, css);

            element.appendChild(icon);

            this.showSubMenuLineWidth(false);
        }
        
    }
    setValueForSubMenuDrawLineWidth(width) {
        this.setWidthForButtonLineWidth(this.menuLineWidthLabel, width);
    }
    drawLineWidthSubMenuAction(e, childIndex) {
        e.stopPropagation();
        if (childIndex < this.drawWidths.length) {
            this.setValueForSubMenuDrawLineWidth(this.drawWidths[childIndex]);
            this.lineWidthCurrentSelected = this.drawWidths[childIndex];
        }
    }


    // draw line dash
    lineDashAction(e) {
        this.showStylingSubMenu(MapDrawStyling.LINE_DASH, false);
        this.lineDashWrapperShow = !this.lineDashWrapperShow;
        this.showSubMenuLineDash(this.lineDashWrapperShow);
    }
    showSubMenuLineDash(isShow) {
        this.lineDashWrapperShow = this.showSubMenuStylingWrapper(isShow, this.lineDashWrapper
            , this.lineDashWrapperShow, this.menuLineDashBtn);
    }
    setValueForButtonLineDash(element, value) {
        if (element && Array.isArray(value) && value.length > 1) {
            element.innerHTML = '';
            
            // create a icon for line dash and is a child of <i> tag
            const icon = document.createElement('div');

            const btnSize = this.drawToolButtonSize / 2;
            const total = value[0] + value[1] + 1;
            const factor = btnSize / total;
            const start1 = 0;
            const stop1 = (value[0] * factor);
            const start2 = stop1 + factor;
            const stop2 = start2 + (value[1] * factor);

            const css = {
                'height': `2px`,
                'border-radius': '5px',
                'width': `${btnSize}px`,
                'background': `repeating-linear-gradient(
                    to right,
                    black ${start1}px,
                    black ${stop1}px,
                    transparent ${stop1}px,
                    transparent ${start2}px,
                    black ${start2}px,
                    black ${stop2}px`,
                'transform': 'rotate(297deg)',
                'margin-left': this.libName === MapLibraryName.OPEN_LAYER ? '10px': '4px',
            };
            Object.assign(icon.style, css);

            element.appendChild(icon);

            this.showSubMenuLineDash(false);
        }
        
    }
    setValueForSubMenuDrawLineDash(value) {
        this.setValueForButtonLineDash(this.menuLineDashLabel, value);
    }
    drawLineDashSubMenuAction(e, childIndex) {
        e.stopPropagation();
        if (childIndex < this.drawDashes.length) {
            this.setValueForSubMenuDrawLineDash(this.drawDashes[childIndex]);
            this.lineDashCurrentSelected = this.drawDashes[childIndex];
        }
    }
    // draw icons
    showSubMenuIcon(isShow) {
        this.iconWrapperShow = this.showSubMenuStylingWrapper(isShow, this.iconWrapper, this.iconWrapperShow
            , this.menuIconBtn);
    }
    iconAction(e) {
        this.showStylingSubMenu(MapDrawStyling.ICON, false);
        this.iconWrapperShow = !this.iconWrapperShow;
        this.showSubMenuIcon(this.iconWrapperShow);
        // console.log(`**** this.iconWrapperShow = ${this.iconWrapperShow}`);
        
    }
    setIconForButtonIcon(element, icon) {
        if (element) {
            const imgId = `${element.id}_img`;
            const imgSrc = this.sclUtilMapService.handleImageFileNo(icon.fileNo);
            if (element.innerHTML.indexOf(imgId) < 0) {
                element.innerHTML = '';
                element.style.height = `${this.drawToolButtonSize}px`;
                element.style.width = `${this.drawToolButtonSize}px`;

                // create a icon for line dash and is a child of <i> tag
                const img = document.createElement('img');
                img.id = imgId;
                img.src = imgSrc;
                img.className = this.cssIconButtonChild;
    
                element.appendChild(img);
            } else {
                const img: any = document.getElementById(imgId);
                img.src = imgSrc;
                this.menuIconBtn.click();
                
            }
            
        }
        
    }
    setIconForMenuDrawIcon(icon) {
        this.setIconForButtonIcon(this.menuIconLabel, icon);
    }
    drawIconChildAction(e, childIndex) {
        e.stopPropagation();
        if (childIndex < this.drawIcons.length) {
            this.setIconForMenuDrawIcon(this.drawIcons[childIndex]);
            this.iconCurrentSelected = this.sclUtilMapService.handleImageFileNo(this.drawIcons[childIndex].fileNo);
            this.iconAnchorCurrentSelected = this.drawIcons[childIndex].imageAnchor ? this.drawIcons[childIndex].imageAnchor : [0.5, 0.5];
            if (this.iconWrapperShow == false) {
                this.drawIconAction(e); // trigger drawing point
            }
        }
    }
    // draw fonts
    showSubMenuFont(isShow) {
        this.fontWrapperShow = this.showSubMenuStylingWrapper(isShow, this.fontWrapper, this.fontWrapperShow
            , this.menuFontBtn);
    }
    fontAction(e) {
        this.showStylingSubMenu(MapDrawStyling.FONT, false);
        this.fontWrapperShow = !this.fontWrapperShow;
        this.showSubMenuFont(this.fontWrapperShow);
        if (this.fontWrapperShow == false) {
            // this.drawIconAction(e); // trigger drawing point
        }
    }
    setFontForButtonFont(element, fontFamily) {
        if (element) {
            const divId = `${element.id}_font`;
            let fontLabel = fontFamily;
            if (fontFamily && fontFamily.trim().length > 0 && fontFamily.indexOf(' ') > -1) {
                fontLabel = fontFamily.split(' ')[0];
            }

            if (element.innerHTML.indexOf(divId) < 0) {
                element.innerHTML = '';
                element.style.height = `${this.drawToolButtonSize}px`;
                element.style.width = `${this.drawToolButtonSize}px`;

                
                // create a icon for line dash and is a child of <i> tag
                const div = document.createElement('div');
                div.id = divId;
                div.innerHTML = fontLabel;
                // div.className = this.cssIconButtonChild;
    
                element.appendChild(div);
            } else {
                const div: any = document.getElementById(divId);
                div.innerHTML = fontLabel;
            }

            this.showSubMenuFont(false);
        }
    }
    setFontForMenuDrawFont(fontFamily) {
        this.setFontForButtonFont(this.menuFontLabel, fontFamily);
    }
    drawFontChildAction(e, childIndex) {
        e.stopPropagation();
        if (childIndex < this.drawFonts.length) {
            this.setFontForMenuDrawFont(this.drawFonts[childIndex]);
            this.fontCurrentSelected = this.drawFonts[childIndex];
        }
    }
    // draw font size
    showSubMenuFontSize(isShow) {
        this.fontSizeWrapperShow = this.showSubMenuStylingWrapper(isShow, this.fontSizeWrapper
            , this.fontSizeWrapperShow, this.menuFontSizeBtn);
    }
    fontSizeAction(e) {
        this.showStylingSubMenu(MapDrawStyling.FONT_SIZE, false);
        this.fontSizeWrapperShow = !this.fontSizeWrapperShow;
        this.showSubMenuFontSize(this.fontSizeWrapperShow);
        if (this.fontSizeWrapperShow == false) {
            // this.drawIconAction(e); // trigger drawing point
        }
    }
    setFontSizeForButtonFontSize(element, fontSize) {
        if (element) {
            element.innerHTML = fontSize;

            this.showSubMenuFontSize(false);
        }
    }
    setFontSizeForMenuDrawFontSize(fontSize) {
        this.setFontSizeForButtonFontSize(this.menuFontSizeLabel, fontSize);
    }
    drawFontSizeChildAction(e, childIndex) {
        e.stopPropagation();
        if (childIndex < this.drawFontSizes.length) {
            this.setFontSizeForMenuDrawFontSize(this.drawFontSizes[childIndex]);
            this.fontSizeCurrentSelected = this.drawFontSizes[childIndex];
        }
    }

    //
    showMenu(isShow) {}
    showMenuButton(isShow) {
        this.menuBtn.style.display = (isShow ? 'block': 'none');
    }
    menuChildAction(childIndex, e) {
        e.stopPropagation();
        if ((this.allowDrawingMode == MapDrawMode.SINGLE && !this.isDrawModeSingle)
           || (this.allowDrawingMode == MapDrawMode.MULTI && this.isDrawModeSingle)) { return; }
    
        this.hideDrawTools();
        this.showMenu(false);
        this.showMenuButton(false);
    
        
    
        switch(childIndex) {
          case 0:
            this.pointBtn.click();
            this.pointBtn.style.display = 'block';
          break;
          case 1:
            this.lineBtn.click();
            this.lineBtn.style.display = 'block';
          break;
          case 2:
            this.polygonBtn.click();
            this.polygonBtn.style.display = 'block';
          break;
          case 3:
            this.circleBtn.click();
            this.circleBtn.style.display = 'block';
          break;
          case 4:
            this.squareBtn.click();
            this.squareBtn.style.display = 'block';
          break;
          case 5:
            this.boxBtn.click();
            this.boxBtn.style.display = 'block';
          break;
          case 6:
            this.textBtn.click();
            this.textBtn.style.display = 'block';
          break;
          case 7:
            this.arrowFirstPointBtn.click();
            this.arrowFirstPointBtn.style.display = 'block';
          break;
          case 8:
            this.arrowLastPointBtn.click();
            this.arrowLastPointBtn.style.display = 'block';
          break;
          case 9:
            this.dimensionBtn.click();
            this.dimensionBtn.style.display = 'block';
          break;
          default: break;
        }
    }

    modeAction(e) {}
    selectAction(e) {}
    locationAction(e) {}
    deleteAction(e) {}
    deleteSelectedShape() {}

    menuAction(e) {}

    pointAction(e) {}
    lineAction(e) {}
    polygonAction(e) {}
    circleAction(e) {}
    squareAction(e) {}
    boxAction(e) {}
    textAction(e) {}
    arrowAtFirstPointAction(e) {}
    arrowAtLastPointAction(e) {}
    drawIconAction(e) {}
    dimensionAction(e) {}
    cancelDrawing() {}
    finishDrawing() {}

    addDrawButtons(layerIds, compId, css, drawMenuChildClassName) {
        for (let i = 0; i < this.drawingToolsSupported.length; i++) {
            if (this.drawingToolsFromConfig.indexOf(this.drawingToolsSupported[i]) > -1
             && this.drawingTools.indexOf(this.drawingToolsSupported[i]) < 0) {
                this.drawingTools.push(this.drawingToolsSupported[i]);
            }
        }
        console.log(`**** drawingTools = ${this.drawingTools}`);

        this.controlBtns = [];
        this.totalDrawTool = 0; // reset

        // button mode: single or multiple
        const objMode = this.createDrawButton(
            /*id*/compId + '_Mode'
        , /*title*/(this.isDrawModeSingle ? 'Single mode' : 'Multi mode')
        , /*text*/(this.isDrawModeSingle ? 'layers_clear' : 'layers')
        , /*css*/css
        , /*actionFunction*/this.modeAction.bind(this), true, null);
        const modeBtn = objMode.btn;
        this.modeLabel = objMode.iSpan;
        this.controlBtns.push(modeBtn);
        layerIds.push(modeBtn.id);

        // button select
        const objSelect = this.createDrawButton(compId + '_Select', 'Select', 'create', css, this.selectAction.bind(this), true, null);
        this.menuSelectBtn = objSelect.btn;
        this.menuSelectLabel = objSelect.iSpan;
        this.controlBtns.push(this.menuSelectBtn);
        layerIds.push(this.menuSelectBtn.id);


        // button menu
        const objMenu = this.createDrawButton(compId + '_Menu', 'Menu', 'menu', css, this.menuAction.bind(this), true, null);
        this.menuBtn = objMenu.btn;
        this.controlBtns.push(this.menuBtn);
        layerIds.push(this.menuBtn.id);

        // button menu - point
        if (this.drawingTools.indexOf('point') > -1) {
            const objPoint = this.createDrawButton(compId + '_mPoint', 'Point', 'pin_drop', css, (e) => this.menuChildAction(0, e), true, null);
            this.menuPointBtn = objPoint.btn;
            this.controlBtns.push(this.menuPointBtn);

            // add point button
            const objPointBtn = this.createDrawButton(compId + '_Point', 'Point', 'pin_drop', css, this.pointAction.bind(this), true, null);
            this.pointBtn = objPointBtn.btn;
            layerIds.push(this.pointBtn.id);
            this.controlBtns.push(this.pointBtn);

            this.totalDrawTool++;
        }

        // button menu - line
        if (this.drawingTools.indexOf('line') > -1) {
            const objLine = this.createDrawButton(compId + '_mLine', 'Line', 'show_chart', css, (e) => this.menuChildAction(1, e), true, null);
            this.menuLineBtn = objLine.btn;
            this.controlBtns.push(this.menuLineBtn);

            // add polyline button
            const objLineBtn = this.createDrawButton(compId + '_Line', 'Line', 'show_chart', css, this.lineAction.bind(this), true, null);
            this.lineBtn = objLineBtn.btn;
            layerIds.push(this.lineBtn.id);
            this.controlBtns.push(this.lineBtn);

            this.totalDrawTool++;
        }

        // button menu - arrowAtFirstPoint for line
        if (this.drawingTools.indexOf('arrowAtFirstPoint') > -1) {
            const title = 'Arrow head at first point';
            const icon = 'call_received';

            const objArrow = this.createDrawButton(compId + '_mArrowFirstPoint', title, icon, css, (e) => this.menuChildAction(7, e), true, null);
            this.menuArrowFirstPointBtn = objArrow.btn;
            this.controlBtns.push(this.menuArrowFirstPointBtn);
  
            const objArrowBtn = this.createDrawButton(compId + '_ArrowFirstPoint', title, icon, css, this.arrowAtFirstPointAction.bind(this), true, null);
            this.arrowFirstPointBtn = objArrowBtn.btn;
            layerIds.push(this.arrowFirstPointBtn.id);
            this.controlBtns.push(this.arrowFirstPointBtn);
  
            this.totalDrawTool++;
        }
        // button menu - arrowAtLastPoint for line
        if (this.drawingTools.indexOf('arrowAtLastPoint') > -1) {
            const title1 = 'Arrow head at last point';
            const icon1 = 'call_made';

            const objArrow1 = this.createDrawButton(compId + '_mArrowLastPoint', title1, icon1, css, (e) => this.menuChildAction(8, e), true, null);
            this.menuArrowLastPointBtn = objArrow1.btn;
            this.controlBtns.push(this.menuArrowLastPointBtn);
  
            const objArrowBtn1 = this.createDrawButton(compId + '_ArrowLastPoint', title1, icon1, css, this.arrowAtLastPointAction.bind(this), true, null);
            this.arrowLastPointBtn = objArrowBtn1.btn;
            layerIds.push(this.arrowLastPointBtn.id);
            this.controlBtns.push(this.arrowLastPointBtn);
  
            this.totalDrawTool++;
        }

        // button menu - polygon
        if (this.drawingTools.indexOf('polygon') > -1) {
            const objPolygon = this.createDrawButton(compId + '_mPolygon', 'Polygon', 'turned_in_not', css, (e) => this.menuChildAction(2, e), true, null);
            this.menuPolygonBtn = objPolygon.btn;
            this.controlBtns.push(this.menuPolygonBtn);

            // add polygon button
            const objPolygonBtn = this.createDrawButton(compId + '_Polygon', 'Polygon', 'turned_in_not', css, this.polygonAction.bind(this), true, null);
            this.polygonBtn = objPolygonBtn.btn;
            layerIds.push(this.polygonBtn.id);
            this.controlBtns.push(this.polygonBtn);

            this.totalDrawTool++;
        }

        // button menu - circle
        if (this.drawingTools.indexOf('circle') > -1) {
            const objCircle = this.createDrawButton(compId + '_mCircle', 'Circle', 'radio_button_unchecked', css, (e) => this.menuChildAction(3, e), true, null);
            this.menuCircleBtn = objCircle.btn;
            this.controlBtns.push(this.menuCircleBtn);

            this.drawButtonsForOnlySingleMode.push(this.menuCircleBtn);

            // add circle button
            const objCircleBtn = this.createDrawButton(compId + '_Circle', 'Circle', 'radio_button_unchecked', css, this.circleAction.bind(this), true, null);
            this.circleBtn = objCircleBtn.btn;
            layerIds.push(this.circleBtn.id);
            this.controlBtns.push(this.circleBtn);

            this.totalDrawTool++;
        }

        
        // button menu - square ( OL )
        if (this.drawingTools.indexOf('square') > -1) {
            const objSquare = this.createDrawButton(
              /*id*/compId + '_mSquare'
            , /*title*/'Square'
            , /*text*/'fit_screen'
            , /*css*/null
            , /*actionFunction*/(e) => this.menuChildAction(4, e), true, null);
            this.menuSquareBtn = objSquare.btn;
            this.controlBtns.push(this.menuSquareBtn);
            this.drawButtonsForOnlySingleMode.push(this.menuSquareBtn);
    
            const objSquareBtn = this.createDrawButton(
              /*id*/compId + '_Square'
            , /*title*/'Square'
            , /*text*/'fit_screen'
            , /*css*/null
            , /*actionFunction*/this.squareAction.bind(this), true, null);
            this.squareBtn = objSquareBtn.btn;
            layerIds.push(this.squareBtn.id);
            this.controlBtns.push(this.squareBtn);
    
            this.totalDrawTool++;
        }

        // button menu - box
        if (this.drawingTools.indexOf('box') > -1) {
            const objBox = this.createDrawButton(compId + '_mBox', 'Box', 'check_box_outline_blank', css, (e) => this.menuChildAction(5, e), true, null);
            this.menuBoxBtn = objBox.btn;
            this.controlBtns.push(this.menuBoxBtn);

            // add box button
            const objBoxBtn = this.createDrawButton(compId + '_Box', 'Box', 'check_box_outline_blank', css, this.boxAction.bind(this), true, null);
            this.boxBtn = objBoxBtn.btn;
            layerIds.push(this.boxBtn.id);
            this.controlBtns.push(this.boxBtn);

            this.totalDrawTool++;
        }

        // button menu - text
        if (this.drawingTools.indexOf('text') > -1) {
            const objText = this.createDrawButton(compId + '_mText', 'Text', 'wysiwyg', css, (e) => this.menuChildAction(6, e), true, null);
            this.menuTextBtn = objText.btn;
            this.controlBtns.push(this.menuTextBtn);

            // add text button
            const objTextBtn = this.createDrawButton(compId + '_Text', 'Text', 'wysiwyg', css, this.textAction.bind(this), true, null);
            this.textBtn = objTextBtn.btn;
            layerIds.push(this.textBtn.id);
            this.controlBtns.push(this.textBtn);

            this.totalDrawTool++;
        }
        // button menu - dimension
        if (this.drawingTools.indexOf('dimension') > -1) {
            const objDimension = this.createDrawButton(compId + '_mDimension', 'Dimension', 'straighten', css, (e) => this.menuChildAction(9, e), true, null);
            this.menuDimensionBtn = objDimension.btn;
            this.controlBtns.push(this.menuDimensionBtn);

            // add Dimension button
            const objDimensionBtn = this.createDrawButton(compId + '_Dimension', 'Dimension', 'straighten', css, this.dimensionAction.bind(this), true, null);
            this.dimensionBtn = objDimensionBtn.btn;
            layerIds.push(this.dimensionBtn.id);
            this.controlBtns.push(this.dimensionBtn);

            this.drawButtonsForOnlySingleMode.push(this.menuDimensionBtn);

            this.totalDrawTool++;
        }

        // button menu - color
        if (this.drawColors.length > 0) {
            const objColor = this.createDrawButton(compId + '_mColor', 'Select drawing color', 'check_box_outline_blank', css, this.colorAction.bind(this), true, null);

            this.menuColorLabel = objColor.iSpan;
            this.setColorForMenuDrawColor(this.drawColors[0]);
            this.menuColorBtn = objColor.btn;
            this.controlBtns.push(this.menuColorBtn);

            const objDraw = this.createDrawButtonStyling(compId, layerIds
                , this.drawStylingButtonCss, this.drawColors
                , this.colorWrapper, '_ColorWrapper', 'draw-color-wrapper-vertical'
                , 'draw-color-wrapper-horizontal', this.drawColorChildAction.bind(this)
                , this.setColorForButtonColor.bind(this), this.menuColorBtn
                , '_Color_', 'check_box_outline_blank', this.elementWrapperForBottomPosition
                , true, null, null);
            layerIds = objDraw.layerIds;
            this.colorWrapper = objDraw.wrapper;

            this.totalDrawTool++;
        }
        // button menu - line width
        if (this.drawWidths.length > 0) {
            const objLineWidth = this.createDrawButton(compId + '_mLineWidth', 'Select drawing width for lines and points'
            , 'check_box_outline_blank', css, this.lineWidthAction.bind(this), true, null);
            
            this.menuLineWidthLabel = objLineWidth.iSpan;
            this.setValueForSubMenuDrawLineWidth(this.drawWidths[0]);
            this.menuLineWidthBtn = objLineWidth.btn;
            this.controlBtns.push(this.menuLineWidthBtn);
    
            const objDraw = this.createDrawButtonStyling(compId, layerIds
                , this.drawStylingButtonCss, this.drawWidths
              , this.lineWidthWrapper, '_LineWidthWrapper', 'draw-color-wrapper-vertical'
              , 'draw-line-width-wrapper-horizontal', this.drawLineWidthSubMenuAction.bind(this)
              , this.setWidthForButtonLineWidth.bind(this), this.menuLineWidthBtn
              , '_Line_Width_', 'check_box_outline_blank', this.elementWrapperForBottomPosition
              , true, null, null);
            layerIds = objDraw.layerIds;
            this.lineWidthWrapper = objDraw.wrapper;
    
            this.totalDrawTool++;
        }
        // button menu - line dash
        if (this.drawDashes.length > 0) {
            // this.cssLineDashDiv = {
            //     'width': `${this.drawToolButtonSize}px`,
            //     'height': `${this.drawToolButtonSize}px`,
            // };
            const objLineDash = this.createDrawButton(compId + '_mLineDash'
            , 'Select drawing dashed for lines', 'check_box_outline_blank', css
            , this.lineDashAction.bind(this), false, null);
        
            this.menuLineDashLabel = objLineDash.iSpan;
            this.setValueForSubMenuDrawLineDash(this.drawDashes[0]);
            this.menuLineDashBtn = objLineDash.btn;
            this.controlBtns.push(this.menuLineDashBtn);
    

            const objDraw = this.createDrawButtonStyling(compId, layerIds
                , this.drawStylingButtonCss, this.drawDashes
              , this.lineDashWrapper, '_LineDashWrapper', 'draw-color-wrapper-vertical'
              , 'draw-line-dash-wrapper-horizontal', this.drawLineDashSubMenuAction.bind(this)
              , this.setValueForButtonLineDash.bind(this), this.menuLineDashBtn
              , '_Line_Dash_', 'check_box_outline_blank', this.elementWrapperForBottomPosition
              , false, null, MapDrawStyling.LINE_DASH);
            layerIds = objDraw.layerIds;
            this.lineDashWrapper = objDraw.wrapper;
    
            this.totalDrawTool++;
        }
        
        // button menu - draw icon
        if (this.drawIcons.length > 0) {
            const objIcon = this.createDrawButton(compId + '_mIcon', 'Select drawing icon', 'photo_library'
            , css, this.iconAction.bind(this), true, MapDrawTypeSpecial.ICON);

            this.menuIconLabel = objIcon.iSpan;
            this.setIconForMenuDrawIcon(this.drawIcons[0]);
            this.menuIconBtn = objIcon.btn;
            this.controlBtns.push(this.menuIconBtn);

            const objDraw = this.createDrawButtonStyling(compId, layerIds
                , this.drawStylingButtonCss, this.drawIcons
                , this.iconWrapper, '_IconWrapper', 'draw-color-wrapper-vertical'
                , 'draw-icon-wrapper-horizontal', this.drawIconChildAction.bind(this)
                , this.setIconForButtonIcon.bind(this), this.menuIconBtn
                , '_Icon_', 'photo_library', this.elementWrapperForBottomPosition
                , true, MapDrawTypeSpecial.ICON, MapDrawStyling.ICON);
            layerIds = objDraw.layerIds;
            this.iconWrapper = objDraw.wrapper;

            this.totalDrawTool++;
        }

        // button menu - draw font
        if (this.drawFonts.length > 0) {
            const objFont = this.createDrawButton(compId + '_mFont', 'Select font', 'abc'
            , css, this.fontAction.bind(this), false, MapDrawStyling.FONT);

            this.menuFontLabel = objFont.iSpan;
            this.menuFontBtn = objFont.btn;
            this.controlBtns.push(this.menuFontBtn);

            const objDraw = this.createDrawButtonStyling(compId, layerIds
                , this.drawStylingButtonCss, this.drawFonts
                , this.fontWrapper, '_FontWrapper', 'draw-color-wrapper-vertical'
                , 'draw-font-wrapper-horizontal', this.drawFontChildAction.bind(this)
                , this.setFontForButtonFont.bind(this), this.menuFontBtn
                , '_Font_', 'abc', this.elementWrapperForBottomPosition
                , false, MapDrawStyling.FONT, null);
            layerIds = objDraw.layerIds;
            this.fontWrapper = objDraw.wrapper;

            this.totalDrawTool++;
        }
        // button menu - draw font size
        if (this.drawFontSizes.length > 0) {
            const objFontSize = this.createDrawButton(compId + '_mFontSize', 'Select font size', 'FS'
            , css, this.fontSizeAction.bind(this), false, MapDrawStyling.FONT_SIZE);

            this.menuFontSizeLabel = objFontSize.iSpan;
            this.setFontSizeForMenuDrawFontSize(this.drawFontSizes[0]);
            this.menuFontSizeBtn = objFontSize.btn;
            this.controlBtns.push(this.menuFontSizeBtn);

            const objDraw = this.createDrawButtonStyling(compId, layerIds
                , this.drawStylingButtonCss, this.drawFontSizes
                , this.fontSizeWrapper, '_FontSizeWrapper', 'draw-color-wrapper-vertical'
                , 'draw-font-wrapper-horizontal', this.drawFontSizeChildAction.bind(this)
                , this.setFontSizeForButtonFontSize.bind(this), this.menuFontSizeBtn
                , '_Font_Size_', 'FS', this.elementWrapperForBottomPosition
                , false, MapDrawStyling.FONT_SIZE, null);
            layerIds = objDraw.layerIds;
            this.fontSizeWrapper = objDraw.wrapper;

            this.totalDrawTool++;
        }

        // add location button
        let locationBtn;
        if (this.drawingTools.indexOf('currentLocation') > -1) {
            const objLocation = this.createDrawButton(compId + '_Current_Location', 'Current Location', 'my_location', css
            , this.locationAction.bind(this), true, null);
            locationBtn = objLocation.btn;
            this.locationElementIcon = objLocation.iSpan;
            this.locationChecked = false;
            layerIds.push(locationBtn.id);
            this.controlBtns.push(locationBtn);
        }

        // add delete button
        let deleteBtn;
        if (this.drawingTools.indexOf('delete') > -1) {
            const objDelete = this.createDrawButton(compId + '_Delete', 'Delete', 'delete', css, this.deleteAction.bind(this), true, null);
            deleteBtn = objDelete.btn;
            layerIds.push(deleteBtn.id);
            this.controlBtns.push(deleteBtn);
        }

        this.drawMenuChild = document.createElement('div');
        this.drawMenuChild.id = compId + '_DrawMenuChild';
        this.drawMenuChild.className = drawMenuChildClassName;
        if (this.isBottom) {
            if (this.menuFontSizeBtn) {
                this.drawMenuChild.appendChild(this.menuFontSizeBtn);
            }
            if (this.menuFontBtn) {
                this.drawMenuChild.appendChild(this.menuFontBtn);
            }
            if (this.menuIconBtn) {
                this.drawMenuChild.appendChild(this.menuIconBtn);
            }
            if (this.menuLineDashBtn) {
                this.drawMenuChild.appendChild(this.menuLineDashBtn);
            }
            if (this.menuLineWidthBtn) {
                this.drawMenuChild.appendChild(this.menuLineWidthBtn);
            }
            if (this.menuColorBtn) {
                this.drawMenuChild.appendChild(this.menuColorBtn);
            }
            if (this.menuDimensionBtn) {
                this.drawMenuChild.appendChild(this.menuDimensionBtn);
            }
            if (this.menuTextBtn) {
                this.drawMenuChild.appendChild(this.menuTextBtn);
            }
            if (this.menuBoxBtn) {
                this.drawMenuChild.appendChild(this.menuBoxBtn);
            }
            if (this.menuSquareBtn) {
                this.drawMenuChild.appendChild(this.menuSquareBtn);
            }
            if (this.menuCircleBtn) {
                this.drawMenuChild.appendChild(this.menuCircleBtn);
            }
            if (this.menuPolygonBtn) {
                this.drawMenuChild.appendChild(this.menuPolygonBtn);
            }
            if (this.menuArrowFirstPointBtn) {
                this.drawMenuChild.appendChild(this.menuArrowFirstPointBtn);
            }
            if (this.menuArrowLastPointBtn) {
                this.drawMenuChild.appendChild(this.menuArrowLastPointBtn);
            }
            if (this.menuLineBtn) {
                this.drawMenuChild.appendChild(this.menuLineBtn);
            }
            if (this.menuPointBtn) {
                this.drawMenuChild.appendChild(this.menuPointBtn);
            }
        } else {
            if (this.menuPointBtn) {
                this.drawMenuChild.appendChild(this.menuPointBtn);
            }
            if (this.menuLineBtn) {
                this.drawMenuChild.appendChild(this.menuLineBtn);
            }
            if (this.menuArrowFirstPointBtn) {
                this.drawMenuChild.appendChild(this.menuArrowFirstPointBtn);
            }
            if (this.menuArrowLastPointBtn) {
                this.drawMenuChild.appendChild(this.menuArrowLastPointBtn);
            }
            if (this.menuPolygonBtn) {
                this.drawMenuChild.appendChild(this.menuPolygonBtn);
            }
            if (this.menuCircleBtn) {
                this.drawMenuChild.appendChild(this.menuCircleBtn);
            }
            if (this.menuSquareBtn) {
                this.drawMenuChild.appendChild(this.menuSquareBtn);
            }
            if (this.menuBoxBtn) {
                this.drawMenuChild.appendChild(this.menuBoxBtn);
            }
            if (this.menuTextBtn) {
                this.drawMenuChild.appendChild(this.menuTextBtn);
            }
            if (this.menuDimensionBtn) {
                this.drawMenuChild.appendChild(this.menuDimensionBtn);
            }
            if (this.menuColorBtn) {
                this.drawMenuChild.appendChild(this.menuColorBtn);
            }
            if (this.menuLineWidthBtn) {
                this.drawMenuChild.appendChild(this.menuLineWidthBtn);
            }
            if (this.menuLineDashBtn) {
                this.drawMenuChild.appendChild(this.menuLineDashBtn);
            }
            if (this.menuIconBtn) {
                this.drawMenuChild.appendChild(this.menuIconBtn);
            }
            if (this.menuFontBtn) {
                this.drawMenuChild.appendChild(this.menuFontBtn);
            }
            if (this.menuFontSizeBtn) {
                this.drawMenuChild.appendChild(this.menuFontSizeBtn);
            }
        }

        this.menuWrapper = document.createElement('div');
        this.menuWrapper.id = compId + '_MenuWrapper';
        if (this.pointBtn) {
            this.menuWrapper.appendChild(this.pointBtn);
        }
        if (this.lineBtn) {
            this.menuWrapper.appendChild(this.lineBtn);
        }
        if (this.arrowFirstPointBtn) {
            this.menuWrapper.appendChild(this.arrowFirstPointBtn);
        }
        if (this.arrowLastPointBtn) {
            this.menuWrapper.appendChild(this.arrowLastPointBtn);
        }
        if (this.polygonBtn) {
            this.menuWrapper.appendChild(this.polygonBtn);
        }
        if (this.circleBtn) {
            this.menuWrapper.appendChild(this.circleBtn);
        }
        if (this.squareBtn) {
            this.menuWrapper.appendChild(this.squareBtn);
        }
        if (this.boxBtn) {
            this.menuWrapper.appendChild(this.boxBtn);
        }
        if (this.textBtn) {
            this.menuWrapper.appendChild(this.textBtn);
        }
        if (this.dimensionBtn) {
            this.menuWrapper.appendChild(this.dimensionBtn);
        }
        
        
        if (this.menuBtn) {
            this.menuWrapper.appendChild(this.menuBtn);
        }
        if (this.drawMenuChild) {
            this.menuWrapper.appendChild(this.drawMenuChild);
        }

        this.showMenu(false);
        this.hideDrawTools();

        for (let i = 0; i < this.controlBtns.length; i++) {
            this.btnAddEvent(this.controlBtns[i]);
        }

        this.drawingMenu.appendChild(modeBtn);
        this.drawingMenu.appendChild(this.menuSelectBtn);
        this.drawingMenu.appendChild(this.menuWrapper);
        if (locationBtn) {
            this.drawingMenu.appendChild(locationBtn);
        }
        if (deleteBtn) {
            this.drawingMenu.appendChild(deleteBtn);
        }
    }
    isEmptyObject(obj) {
        const propertyCount = Object.keys(obj).length;
        if (propertyCount == 0) {
            return true;
        }
        let emptyCount = 0;
        for (let prop in obj) {
            if (obj[prop] == null) {
                emptyCount++;
            }
        }
        if (emptyCount == propertyCount) {
            return true;
        }
        
        return false;
    }

    normalizeProperties(properties, geomType, sharedId) {
        const p = cloneDeep(properties);
        if (geomType === MapDrawType.MULTI_POINT) {
          p.idGroup = ShapeIdGroup.MULTI_POINT;
        } else if (geomType === MapDrawType.MULTI_LINE_STRING) {
          p.idGroup = ShapeIdGroup.MULTI_LINE_STRING;
        } else if (geomType === MapDrawType.MULTI_POLYGON) {
          p.idGroup = ShapeIdGroup.MULTI_POLYGON;
        }
        p.sharedId = sharedId;
        return p;
    }
    normalizeGeoJson(geojson) {
        if (!geojson || geojson.type !== GEOJSON_TYPE.FEATURE_COLLECTION || !Array.isArray(geojson.features)) {
          throw new Error("Invalid GeoJSON FeatureCollection");
        }
      
        const result = {
          type: GEOJSON_TYPE.FEATURE_COLLECTION,
          features: []
        };
      
        for (let i = 0; i < geojson.features.length; i++) {
          const feature = geojson.features[i];
          if (feature.type === FEATURE_TYPE.FEATURE && feature.geometry?.type === FEATURE_TYPE.GEOMETRY_COLLECTION) {
            // split geometries into features
            const geometries = feature.geometry.geometries;
            for (const geom of geometries) {
              const p = this.normalizeProperties(feature.properties, geom.type, i.toString());
    
              result.features.push({
                type: FEATURE_TYPE.FEATURE,
                geometry: geom,
                properties: p // same properties
              });
            }
          } else if (feature.type === FEATURE_TYPE.GEOMETRY_COLLECTION) {
            // if there has wrong format of GeometryCollection
            for (const geom of feature.geometries || []) {
              const p = this.normalizeProperties(feature.properties, geom.type, i.toString());
    
              result.features.push({
                type: FEATURE_TYPE.FEATURE,
                geometry: geom,
                properties: p
              });
            }
          } else {
            // normal feature stay the same
            result.features.push(feature);
          }
        }
      
        return result;
    }
    
}